import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "timi-project-container" }
const _hoisted_2 = { class: "timi-project-detail-content" }
const _hoisted_3 = { class: "timi-detail-column column-33" }
const _hoisted_4 = { class: "ww-data-list-item" }
const _hoisted_5 = { class: "ww-data-list-item" }
const _hoisted_6 = { class: "ww-data-list-item" }
const _hoisted_7 = { class: "ww-data-list-item" }
const _hoisted_8 = { class: "ww-data-list-item" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "/", -1)
const _hoisted_10 = { class: "ww-data-list-item" }
const _hoisted_11 = { class: "ww-data-list-item" }
const _hoisted_12 = { class: "ww-data-list-item" }
const _hoisted_13 = { class: "ww-data-list-item" }
const _hoisted_14 = { class: "ww-data-list-item" }
const _hoisted_15 = { class: "ww-data-list-item" }
const _hoisted_16 = { class: "ww-card-actions" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "ww-verticale-divider" }, null, -1)
const _hoisted_18 = { class: "ww-data-list-item bold" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "ww-data-list-item bold" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "ww-data-list-item bold" }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "timi-detail-column column-grow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_Switch = _resolveComponent("Switch")!
  const _component_DataList = _resolveComponent("DataList")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_IconButton, {
      icon: _ctx.store.getters.svgIcons.arrowbackward,
      class: "go-back-btn",
      label: _ctx.$t('button.back'),
      dense: true,
      onOnClick: _ctx.handleGoBack
    }, null, 8, ["icon", "label", "onOnClick"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Card, {
          title: _ctx.$t('project.infos')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DataList, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.projectNumberExternal')), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.project.numberExternal ? _ctx.project.numberExternal  : "-"), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.projectNumberInternal')), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.project.numberInternal ? _ctx.project.numberInternal  : "-"), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.projectNumberSerial')), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.project.numberSerial ? _ctx.project.numberSerial  : "-"), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.projectName')), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.project.title ? _ctx.project.title  : "-"), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('project.projectCreated')), 1),
                  _hoisted_9
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.active')), 1),
                  _createVNode(_component_Switch, {
                    class: "active-switch",
                    mini: true,
                    name: "formMode",
                    onOnChange: _ctx.handleToggleActiveProject,
                    value: _ctx.project.active
                  }, null, 8, ["onOnChange", "value"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.client')), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.project.customer ? _ctx.project.customer.custName : ""), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.accounted')), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.project.accounted ? _ctx.$t('label.yes') : _ctx.$t('label.no')), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.budgetTime')), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.project.timeBudget ? _ctx.project.timeBudget : "-"), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.budgetMoney')), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.project.moneyBudget ? _ctx.project.moneyBudget : "-"), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.salesActual')), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.project.salesActual ? _ctx.project.salesActual : "-"), 1)
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_Button, {
                text: _ctx.$t('button.edit'),
                dense: true,
                onOnClick: _ctx.handleEdit
              }, null, 8, ["text", "onOnClick"]),
              _hoisted_17,
              _createVNode(_component_Button, {
                text: _ctx.$t('button.delete'),
                dense: true,
                onOnClick: _ctx.handleDelete
              }, null, 8, ["text", "onOnClick"])
            ])
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_Card, {
          title: _ctx.$t('label.project_hours')
        }, {
          default: _withCtx(() => [
            (_ctx.getTimeByActivity.length)
              ? (_openBlock(), _createBlock(_component_DataList, { key: 0 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.totalTime')), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.convertSecondsToHours(_ctx.totalProjectTime)), 1)
                    ])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t('emptyState.default')), 1))
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_Card, {
          title: _ctx.$t('label.hours_per_work')
        }, {
          default: _withCtx(() => [
            (_ctx.getTimeByActivity.length)
              ? (_openBlock(), _createBlock(_component_DataList, { key: 0 }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTimeByActivity, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.uid,
                        class: "ww-data-list-item"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(item.title), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.convertSecondsToHours(item.time)), 1)
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.totalTime')), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.convertSecondsToHours(_ctx.totalTimeByActivity)), 1)
                    ])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t('emptyState.default')), 1))
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_Card, {
          title: _ctx.$t('label.employee')
        }, {
          default: _withCtx(() => [
            (_ctx.getTimeByEmployee.length)
              ? (_openBlock(), _createBlock(_component_DataList, { key: 0 }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTimeByEmployee, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.uid,
                        class: "ww-data-list-item"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(item.name), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.convertSecondsToHours(item.time)), 1)
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.totalTime')), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.convertSecondsToHours(_ctx.totalTimeByEmployee)), 1)
                    ])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t('emptyState.default')), 1))
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_Table, {
          tableData: _ctx.worksTableData,
          src: _ctx.projectTimeEntries
        }, null, 8, ["tableData", "src"])
      ])
    ])
  ]))
}